import { LessonCourseDefaultThumbnail } from '@/constant/imgImport';
import { styled } from '@mui/material';
import Image from 'next/image';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import DocumentThumbnail from '../../DocumentThumbnail/DocumentThumbnail';
import FoldedPaperCorner from '../components/FoldedPaperCorner';

const ThumbnailDisplay = ({
  thumbnail,
  fileType,
  ...props
}: { thumbnail: string | null; fileType: string } & DetailedHTMLProps<
  HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) => {
  return (
    <div {...props} className={twMerge('relative', props.className)}>
      <StyledDiv className="h-fit overflow-hidden rounded-lg border border-Other/Outlinedborder-stroke">
        <Image
          height={112}
          width={87}
          objectFit={thumbnail ? 'contain' : 'cover'}
          src={thumbnail || LessonCourseDefaultThumbnail}
          className={`select-none`}
          alt="document thumbnail"
        />
      </StyledDiv>
      <FoldedPaperCorner className="absolute -right-1 -top-1 z-[9]" />
      <DocumentThumbnail
        type={fileType.toLowerCase().includes('pdf') ? 'PDF' : 'Word'}
        className="absolute left-[42px] top-[80px]"
      />
    </div>
  );
};

export default ThumbnailDisplay;

const StyledDiv = styled('div')`
  clip-path: polygon(0 0, calc(100% - 28px) 0, 100% 26px, 100% 100%, 0 100%);
  -webkit-clip-path: polygon(
    0 0,
    calc(100% - 28px) 0,
    100% 26px,
    100% 100%,
    0 100%
  );
`;
